import { mapActions, mapState } from 'vuex';
import funcoes from "../../../util/funcoes.js";
import AppPagarReciboDialog from '../../clientes/dialogs/PagarReciboDialog.vue';
import AppPagarBoletoAvulsoDialog from '../../contratos/dialogs/PagarBoletoAvulsoDialog.vue';
import { STATUS_RECIBO_REPASSE, STATUS_CONTRATO_ALUGUEL } from '../../../util/constantes.js';

export default {
  components: {
    AppPagarReciboDialog,
    AppPagarBoletoAvulsoDialog
  },
  data() {
    return {
      // ALUGUEIS
      baixa: {
        status: 'EM_ABERTO',
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        numero: undefined,
        cliente: {
          id: 0
        }
      },
      tipoDataPagamento: 'DATA_PAGAMENTO',

      //PAGINAÇÃO
      currentPageAlugueis: 1,
      currentPageBoletosAvulsos: 1,
      maxItens: 100,

      //FILTROS
      contrato: undefined,
      loadingClientes: false,
      loadingImovel: false,

      reciboSelecionado: undefined,
      visibilidadePagarReciboDialog: false,

      // BOLETOS AVULSOS
      baixaBoleto: {
        status: 'EM_ABERTO',
        dataVencimentoInicio: funcoes.primeiroDiaMes(),
        dataVencimentoFim: funcoes.ultimoDiaMes(),
        numero: undefined,
        cliente: {
          id: 0
        }
      },

      boletoAvulsoSelecionado: undefined,
      visibilidadePagarBoletoAvulsoDialog: false,

      // GERAL
      tabSelecionada: 'alugueis',
      statusRecibos: [
        { label: 'Em Aberto', data: 'EM_ABERTO' },
        { label: 'Pago', data: 'PAGO' }
      ]
    }
  },

  computed: {
    ...mapState('baixasStore', {
      alugueis(state) { return state.alugueis.filter(item => { return this.contrato ? (item.aluguel.idNaImobiliaria.includes(this.contrato)) : true}).slice((this.currentPageAlugueis - 1 ) * this.maxItens, this.currentPageAlugueis * this.maxItens) },
      quantidadeAlugueis(state){ return state.alugueis.filter(item => { return this.contrato ? item.aluguel.idNaImobiliaria.includes(this.contrato) : true }).length },
      boletosAvulsos(state) { return state.boletosAvulsos.filter(item => { return this.contrato ? (item.aluguel.idNaImobiliaria.includes(this.contrato)) : true}).slice((this.currentPageBoletosAvulsos - 1 ) * this.maxItens, this.currentPageBoletosAvulsos * this.maxItens) },
      quantidadeBoletosAvulsos(state){ return state.boletosAvulsos.filter(item => { return this.contrato ? (item.aluguel.idNaImobiliaria.includes(this.contrato)) : true}).length },
      clientesDisponiveis(state){  return state.listaClientes.lista; }
    }),
    exibirTipoData() {
      return this.baixa.status === 'PAGO'
    },
    exibirCampoBaixaAluguel() {
      return this.tabSelecionada == 'alugueis';
    },
    exibirCampoBaixaBoletoAvulso() {
      return this.tabSelecionada == 'boletosAvulsos';
    },
    labelQuantidadeBaixas() {
      switch (this.alugueis.length) {
          case 1:
              return `Exibindo 1 Aluguel`
          case 0:
              return '';
          default:
              return `Exibindo ${(this.currentPageAlugueis - 1) * this.maxItens + 1} a ${(this.currentPageAlugueis - 1) * this.maxItens + this.alugueis.length} de ${this.quantidadeAlugueis} Alugueis`
      }
    },
    labelQuantidadeBoletos() {
      switch (this.boletosAvulsos.length) {
          case 1:
              return `Exibindo 1 boleto avulsos`
          case 0:
              return '';
          default:
              return `Exibindo ${(this.currentPageBoletosAvulsos - 1) * this.maxItens + 1} a ${(this.currentPageBoletosAvulsos - 1) * this.maxItens + this.boletosAvulsos.length} de ${this.quantidadeBoletosAvulsos} Boletos Avulsos`
      }
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),

    ...mapActions('baixasStore', [
      'listarAlugueis',
      'listarClientes',
      'listarBoletosAvulsos',
      'limparAlugueis',
      'limparBoletosAvulsos'
    ]),
    listarAlugueisHandler() {
      this.showLoading();
      this.baixa.cliente = {
        id: this.baixa.cliente.id
      }
      const payload = Object.assign({}, this.baixa);

      if (this.baixa.status === 'EM_ABERTO') {
        payload.dataVencimentoInicio = this.baixa.dataInicial;
        payload.dataVencimentoFim = this.baixa.dataFinal;
      } else {
        switch (this.tipoDataPagamento) {
          case 'DATA_PAGAMENTO':
            payload.dataPagamentoInicio = this.baixa.dataInicial;
            payload.dataPagamentoFim = this.baixa.dataFinal;
            break;
          case 'DATA_BAIXA':
            payload.dataBaixaInicio = this.baixa.dataInicial;
            payload.dataBaixaFim = this.baixa.dataFinal;
            break;
        }
      }

      delete payload.dataInicial;
      delete payload.dataFinal;
      this.currentPageAlugueis = 1;

      this.listarAlugueis(payload)
        .then(() => {
          this.hideLoading();
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },


    listarBoletosAvulsosHandler() {
      this.showLoading();
      this.currentPageBoletosAvulsos = 1;
      this.baixaBoleto.cliente = {
        id: this.baixaBoleto.cliente.id
      }
      this.listarBoletosAvulsos(this.baixaBoleto)
        .then(() => {
          this.hideLoading();
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    // DIALOGS
    handleExibirPagarReciboDialog(recibo) {
      const reciboIsPago = recibo.status === 'PAGO';
      if(reciboIsPago) return;

      this.exibirPagarReciboDialog(recibo);
    },
    exibirPagarReciboDialog(recibo) {
      this.reciboSelecionado = recibo
      this.visibilidadePagarReciboDialog = true
    },
    fecharPagarReciboDialog() {
      this.visibilidadePagarReciboDialog = false;
    },
    concluirPagamentoRecibo() {
      this.visibilidadePagarReciboDialog = false;
      this.listarAlugueisHandler();
    },

    handleExibirPagarBoletoAvulsoDialog(boletoAvulso) {
      const boletoAvulsoIsPago = boletoAvulso.status === 'PAGO';
      if(boletoAvulsoIsPago) return;
      
      this.exibirPagarBoletoAvulsoDialog(boletoAvulso);
    },
    exibirPagarBoletoAvulsoDialog(boletoAvulso) {
      this.boletoAvulsoSelecionado = boletoAvulso
      this.visibilidadePagarBoletoAvulsoDialog = true
    },
    fecharPagarBoletoAvulsoDialog(statusPagamento) {
      this.visibilidadePagarBoletoAvulsoDialog = false;

      if(statusPagamento === 'SUCESSO') this.listarBoletosAvulsosHandler();
    },
    //SELECT CLIENTES
    filtrarClientesSelect(queryString) {
      let payload = {};
      let reg = /^\d+$/;

      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString;
      this.loadingClientes = true
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        }).catch(() => {
          this.loadingClientes = false;
        });
    },
    // UTIL
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    getLabelStatus(item) {
      return funcoes.getLabel(STATUS_RECIBO_REPASSE, item.status)
    },
    getLabelStatusAluguel(item) {
      return funcoes.getLabel(STATUS_CONTRATO_ALUGUEL, item.aluguel.status)
    },
    formatarValor(item) {
      return funcoes.formatarValor(item)
    },
    formatarIconStatus(item) {
      switch (item) {
        case 'EM_ABERTO':
          return '#4B6EF6'; 
        case 'PAGO':
          return '#2DB748';
      }
    },
    //RESET
    resetCliente(){
      this.baixaBoleto.cliente = {id: 0};
      this.baixa.cliente = {id: 0};
    },
  }
}